// removed by extract-text-webpack-plugin
module.exports = {"news-block":"_3CnfvS5fxFoibIrCHDD0Rd","frontpage":"_2C1PeoWnch2RmyH0aKDP8F","horizontal":"QKORg33EWKa81JpKrxW9l","text":"_1qSJuvSKqTlTybjXDblxO0","heading":"w1RKPzz7tFRR-qqY9l9ay","paragraph":"nYa_p999EABXG92_gMrph","link":"_3CyXkiPq2CEH7MPmMbz4kk","image":"_3tUV5iLaqF_S6WB0A8A-yS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewsBlock/NewsBlock.module.scss
// module id = 791
// module chunks = 0